import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    catalogPlugin.getExtension('page:catalog').override({
      params: {
        title: 'Volkswagen Software Catalog',
        loader: async () => {
          const { CustomCatalogPage } = await import('../components/catalog/CatalogPage');
          return <CustomCatalogPage />;
        },
      },
    }),
    EntityContentBlueprint.make({
      name: 'overview',
      params: {
        path: '/',
        title: 'Overview',
        loader: async () => {
          const { EntityOverviewContent } = await import('../components/catalog/EntityPage');
          return <EntityOverviewContent />;
        },
      },
    }),
    EntityContentBlueprint.make({
      name: 'ci-cd',
      params: {
        path: '/ci-cd',
        title: 'CI/CD',
        filter: entity =>
          entity.kind.toLocaleLowerCase('en-US') === 'component' &&
          ['service', 'website'].includes(
            String(entity.spec?.type ?? '').toLocaleLowerCase('en-US'),
          ),
        loader: async () => {
          const { EntityCiCdContent } = await import('../components/catalog/EntityPage');
          return <EntityCiCdContent />;
        },
      },
    }),
    EntityContentBlueprint.make({
      name: 'service-api',
      params: {
        path: '/api',
        title: 'API',
        filter: entity =>
          entity.kind.toLocaleLowerCase('en-US') === 'component' &&
          String(entity.spec?.type ?? '').toLocaleLowerCase('en-US') === 'service',
        loader: async () => {
          const { EntityServiceApiContent } = await import('../components/catalog/EntityPage');
          return <EntityServiceApiContent />;
        },
      },
    }),
    EntityContentBlueprint.make({
      name: 'dependencies',
      params: {
        path: '/dependencies',
        title: 'Dependencies',
        filter: entity =>
          entity.kind.toLocaleLowerCase('en-US') === 'component' &&
          ['service', 'website'].includes(
            String(entity.spec?.type ?? '').toLocaleLowerCase('en-US'),
          ),
        loader: async () => {
          const { EntityDependenciesContent } = await import('../components/catalog/EntityPage');
          return <EntityDependenciesContent />;
        },
      },
    }),
    EntityContentBlueprint.make({
      name: 'definition',
      params: {
        path: '/definition',
        title: 'Definition',
        filter: entity => entity.kind.toLocaleLowerCase('en-US') === 'api',
        loader: async () => {
          const { EntityApiDefinitionContent } = await import('../components/catalog/EntityPage');
          return <EntityApiDefinitionContent />;
        },
      },
    }),
    EntityContentBlueprint.make({
      name: 'diagram',
      params: {
        path: '/diagram',
        title: 'Diagram',
        filter: entity => entity.kind.toLocaleLowerCase('en-US') === 'system',
        loader: async () => {
          const { EntityDiagramContent } = await import('../components/catalog/EntityPage');
          return <EntityDiagramContent />;
        },
      },
    }),
  ],
});

export const catalogImportModule = createFrontendModule({
  pluginId: 'catalog-import',
  extensions: [
    catalogImportPlugin.getExtension('page:catalog-import').override({
      params: {
        title: 'Register Existing Component',
        loader: async () => {
          const { ProtectedCatalogImportPage } = await import('../components/catalog/CatalogImportPage');
          return <ProtectedCatalogImportPage />;
        },
      },
    }),
  ],
});
